import { Link, useNavigate } from 'react-router-dom';
import React, { useState } from 'react';

import { useUser } from "../component/userContext";

import { Dropdown } from 'react-bootstrap';
import { getAuth } from 'firebase/auth';


const Navigation = () => {
    const navigate = useNavigate();
    // const { isDarkMode, toggleTheme } = useTheme();


    const navigateToHome = () => {
        const homeSection = document.querySelector('#home');
        navigate('/');
        if (homeSection) {
          homeSection.scrollIntoView({ behavior: 'smooth' });
        }
      }

    const [isCollapsed, setIsCollapsed] = useState(true);
    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    }

    const { user, setUser } = useUser();
    const [showDropdown, setShowDropdown] = useState(false);
    const isLoggedIn = user !== null;

    const handleDropdownToggle = (isOpen) => {
        setShowDropdown(isOpen);
    };
    
    const auth = getAuth();

    const handleLogout = () => {
        auth.signOut().then(() => {
          setUser(null);
        });
    };

    return(
        <nav className="navbar-example2 navbar navbar-expand-lg sticky-top">
            <div className="container">
                <Link to='/' className="navbar-brand d-flex align-items-center" style={{ textDecoration: 'none', color: 'var(--blackColor)' }}>
                    <img src="/logo.png" alt="familytopup" width="45" height="45" className="me-2 rounded-circle shadow-4-strong"/>
                    <span style={{ fontWeight: 600 }}>FamilyTopUp</span>
                </Link>

                <button onClick={toggleCollapse} className="navbar-toggler" type="button">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className={`collapse navbar-collapse ${isCollapsed ? '' : 'show'}`} id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0 mx-auto">
                        <li className="nav-item">
                            <Link to='/#home' className='nav-link mx-2' onClick={navigateToHome}>
                                Home
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to='/track' className='nav-link mx-2'>
                                Cek Pesanan
                            </Link>
                        </li>
                    </ul>
                    <div className="d-flex align-items-center btnWrapper mt-lg-0 mt-5">

                        {isLoggedIn ? (
                            <Dropdown onToggle={handleDropdownToggle} className='ms-2'>
                                <Dropdown.Toggle as="div" className="user-profile-toggle d-flex align-items-center" id="dropdown-basic" style={{ cursor: 'pointer' }}>
                                    <img 
                                        src={user.photoURL || '/logo.png'} 
                                        onError={(e) => { e.currentTarget.src = '/logo.png'; }} 
                                        alt={user.displayName || 'User'} 
                                        className="rounded-circle" 
                                        style={{ height: '35px', width: '35px', objectFit: 'cover', background: 'white' }} 
                                    />
                                    <i className="bi bi-chevron-down ms-2 small" style={{ color: 'var(--textColor)' }}></i>
                                </Dropdown.Toggle>
                            <Dropdown.Menu show={showDropdown}>
                                <Dropdown.Item onClick={() => navigate('/profile')}>
                                <i className="bi bi-grid-fill" /> Dashboard
                                </Dropdown.Item>
                                {/* <Dropdown.Item onClick={() => navigate('/redeem')}>
                                <i className="bi bi-gift-fill" /> Redeem Voucher
                                </Dropdown.Item> */}
                                {user && user.level === 'Admin' && (
                                    <Dropdown.Item onClick={() => navigate('/admin')} className="text-warning fw-bold">
                                        <i className="bi bi-shield-lock-fill" /> Admin Panel
                                    </Dropdown.Item>
                                )}
                                <Dropdown.Divider />
                                <Dropdown.Item onClick={handleLogout}>
                                <i className="bi bi-box-arrow-right" /> Logout
                                </Dropdown.Item>
                            </Dropdown.Menu>
                            </Dropdown>
                        ) : (
                            <button onClick={() => navigate('/login')} className="w-100 mx-2 secondaryBtn">
                            Masuk
                            </button>
                        )}

                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navigation;